<div class="ap-margin-bottom-3">{{ 'financial-obligations.student-debt.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}</div>
<ap-amount-input
    id="studentDebtAmount"
    [label]="'global.monthly-input.label' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
    [helpText]="'financial-obligations.student-debt.help-text' | apContent"
>
</ap-amount-input>

<additional-info
    [key]="questionKey"
    id="studentDebtHint"
    titleKey="financial-obligations.student-debt.amount.additional-info.title"
    contentKey="financial-obligations.student-debt.amount.additional-info.content"
    modalUrlKey="financial-obligations.student-debt.amount.additional-info.url-text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
